import React from "react"
import Icon from "@ant-design/icons"

const CloseIconSVG = props => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="19.8572"
      width="25.2538"
      height="3.03045"
      rx="1"
      transform="rotate(-45 2 19.8572)"
      fill="#4F4B4A"
    />
    <rect
      x="2"
      y="4.14282"
      width="3.03045"
      height="25.2538"
      rx="1"
      transform="rotate(-45 2 4.14282)"
      fill="#4F4B4A"
    />
  </svg>
)

const CloseIcon = props => <Icon component={CloseIconSVG} {...props} />

export default CloseIcon
